import { decrypt, encrypt } from '@/assets/functions/security'
import { SessionLogout, SessionTokenRefresh } from 'api/account/account'
import Cookies from 'universal-cookie'

class AuthService {
  cookies: Cookies

  constructor() {
    this.cookies = new Cookies()
  }

  setTokenInCookies(key: string, value: string) {
    const token = value || ''
    const encryptedValue = encrypt(token)
    const isDev = window.location.hostname === 'localhost'
    const date = new Date()
    date.setDate(date.getDate() + 2)

    const cookieOptionsDev = {
      path: '/',
      expires: date
    }

    const cookieOptionsProd = {
      path: '/',
      expires: date,
      domain: '.kroemtech.ch',
      sameSite: 'none',
      secure: true
    }

    this.cookies.set(
      key,
      encryptedValue,
      isDev ? cookieOptionsDev : cookieOptionsProd
    )
  }

  updateAccessToken(val: string) {
    this.setTokenInCookies('_atc', val)
  }

  updateRefreshToken(val: string) {
    this.setTokenInCookies('_rtc', val)
  }

  updateFirstName(val: string) {
    const name = encrypt(val)
    const isDev = window.location.hostname === 'localhost'
    const date = new Date()
    date.setDate(date.getDate() + 2)

    const cookieOptionsDev = {
      path: '/',
      expires: date
    }

    const cookieOptionsProd = {
      path: '/',
      expires: date,
      domain: '.kroemtech.ch',
      sameSite: 'none',
      secure: true
    }
    this.cookies.set('_nac', name, isDev ? cookieOptionsDev : cookieOptionsProd)
  }

  async logoutAccount() {
    const isDev = window.location.hostname === 'localhost'
    let accessToken = this.cookies.get('_atc')
    accessToken = accessToken ? decrypt(accessToken) : ''

    try {
      await SessionLogout(accessToken)
      this.cookies.remove('_atc', {
        path: '/',
        domain: isDev ? undefined : '.kroemtech.ch'
      }) // access token
      this.cookies.remove('_rtc', {
        path: '/',
        domain: isDev ? undefined : '.kroemtech.ch'
      }) // refresh token
      this.cookies.remove('_nac', {
        path: '/',
        domain: isDev ? undefined : '.kroemtech.ch'
      }) // name
      window.location.href = '/en'
    } catch (error) {
      console.error('Logout error:', error)
    }
  }

  async doTokenRefresh() {
    let refreshToken = this.cookies.get('_rtc')
    refreshToken = refreshToken ? decrypt(refreshToken) : ''

    try {
      const res: any = await SessionTokenRefresh(refreshToken)
      if (res.ok) {
        this.updateRefreshToken(res.message.refreshToken)
        this.updateAccessToken(res.message.accessToken)
        return { ok: true, accessToken: res.message.accessToken }
      }
    } catch (error) {
      console.error('Token refresh error:', error)
    }
    return { ok: false }
  }

  loadCookies() {
    let accessToken = this.cookies.get('_atc')
    let refreshToken = this.cookies.get('_rtc')
    let firstName = this.cookies.get('_nac')

    try {
      accessToken = accessToken ? decrypt(accessToken) : ''
      refreshToken = refreshToken ? decrypt(refreshToken) : ''
      firstName = firstName ? decrypt(firstName) : ''
    } catch (error) {
      console.error('Error decrypting cookies:', error)
      accessToken = ''
      refreshToken = ''
      firstName = ''
    }

    return {
      accessToken,
      refreshToken,
      firstName,
      isLoggedIn: !!firstName && !!accessToken
    }
  }
}

export default new AuthService()
